import type { ReactNode } from 'react';
import Text, { TEXT_TAG, TEXT_VARIANT } from '@pixum/text';
import styles from './CartStepLayout.module.css';

interface CartStepLayoutProps {
  title: string;
  titleId?: string;
  stepHeader?: ReactNode;
  stepFooter?: ReactNode;
  children: ReactNode;
}

export function CartStepLayout({ title, titleId, stepHeader, stepFooter, children }: CartStepLayoutProps) {
  return (
    <div className={styles.stepLayout}>
      <div className={styles.headingRow}>
        <Text id={titleId} variant={TEXT_VARIANT.TITLE_2} tag={TEXT_TAG.H1}>
          {title}
        </Text>
        {stepHeader}
      </div>
      {children}
      {stepFooter && <div className={styles.actions}>{stepFooter}</div>}
    </div>
  );
}
